<template>
  <div class="icon-button button-cancel pt usn action-button">
    <em
      :style="getCustomIconStyle(iconPath(icon))"
      class="custom-icons card-action-icon bg-icon-default group-hover:bg-icon-hover"
    />
  </div>
</template>

<script setup lang="ts">
import useCustomIcon from '@/utilities/composables/useCustomIcon';

const { iconPath, getCustomIconStyle } = useCustomIcon();

defineProps({
  icon: {
    type: String,
    required: true,
    default: '',
  },
});
</script>

<style lang="scss">
.icon-button {
  @apply flex rounded items-center justify-center box-border bg-important-bg hover:bg-important-hover border border-solid border-important-border h-6 w-6;
}
</style>
